import { SxProps, Theme } from '@mui/material';

export const loadMoreButtonStyles = {
  container: (theme: Theme) =>
    ({
      display: 'flex',
      justifyContent: 'flex-end',
      width: '100%',
      padding: theme.spacing(0.5, 0),
    }) as SxProps<Theme>,

  button: (theme: Theme) =>
    ({
      minWidth: 0,
      padding: theme.spacing(0.5, 1),
      color: theme.palette.primary.main,
      fontSize: '18px',
      fontStyle: 'normal',
      fontWeight: theme.typography.fontWeightRegular,
      '&:hover, &:active': {
        backgroundColor: 'transparent',
      },
      // Override the legacy global button focus ring, then restore one keyboard-only outline.
      '&:focus': {
        border: 'none !important',
        outline: 'none !important',
      },
      '&:focus-visible': {
        outline: `2px solid ${theme.palette.primary.main} !important`,
        outlineOffset: '2px',
      },
    }) as SxProps<Theme>,
};

export default loadMoreButtonStyles;
